import React, { useEffect, useState } from "react";
import { createPromoteKitCheckoutSessionUser, getPlanForAffiliateUser } from "../core/_requests";
import { useNavigate, useLocation } from "react-router-dom";
import { Plan, PlanDetail } from "../core/_models";
import { toast } from "react-toastify";
import SocialMediaIcons from "./SocialMedia";
import SalesPageHeader from "./SalesPageHeader";
import SalesPageFooter from "./SalesPageFooter";

const SalesPageUserPromoteKit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState<Plan[]>([]);
  const [subscribedActivePlan, setSubscribedActivePlan] = useState<Plan | null>(null);
  const [subscribingPlan, setSubscribingPlan] = useState<string | null>(null);
  const [selectedPlanOption, setSelectedPlanOption] = useState<{ [key: string]: PlanDetail | null }>({});
  const [activeFeatureId, setActiveFeatureId] = useState<number | null>(null);

  const handleInfoClick = (id: number) => {
    setActiveFeatureId((prevId) => (prevId === id ? null : id)); // Toggle the tooltip
  };
  const getPlanIdFromURL = () => {
    const urlParamsString = location.search.split('?')[1]; // Get the part after `?`

    if (!urlParamsString) return { planId: null, via: null };

    const urlParamsArray = urlParamsString.split('&'); // Split by '&' for multiple parameters

    // Define the params object with an explicit type
    const params: { [key: string]: string } = {};

    urlParamsArray.forEach(param => {
      const [key, value] = param.split('=');
      if (key && value) {
        params[key] = value;
      }
    });

    // Return the values with explicit typing
    return {
      planId: params['planId'] || null,
      via: params['via'] || null
    };
  };
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (activeFeatureId !== null) {
      // Set a timeout to hide the tooltip after 10 seconds
      // timer = setTimeout(() => {
      //   setActiveFeatureId(null);
      // }, 10000); // 10 seconds
    }

    // Cleanup the timeout if the component unmounts or activeFeatureId changes
    // return () => {
    //   if (timer) {
    //     clearTimeout(timer);
    //   }
    // };
  }, [activeFeatureId]);

  const getActiveDetail = (plan: Plan) =>
    plan.plan_details.find(detail => detail.isActive) || plan.plan_details[0];

  const fetchPlans = async () => {
    try {
      const res = await getPlanForAffiliateUser();
      const plansData: Plan[] = res?.data || [];
      setPlans(plansData);

      const activePlans = plansData.filter((plan: Plan) => plan.isPlanActive); // Filter active plans
      const initialSelectedOptions: { [key: string]: PlanDetail | null } = {};

      activePlans.forEach((activePlan: Plan) => {
        setSubscribedActivePlan(activePlan);

        // Attempt to find the active detail first
        const activeDetail = activePlan.plan_details.find((detail: PlanDetail) => detail.isActive);

        const selectedDetail = getActiveDetail(activePlan) || activePlan.plan_details[0];
        if (selectedDetail) {
          initialSelectedOptions[activePlan.id] = {
            amount: selectedDetail.amount,
            originalAmount: selectedDetail.originalAmount,
            validity: selectedDetail.validity,
            validityCount: selectedDetail.validityCount,
            type: selectedDetail.type,
            isActive: selectedDetail.isActive,
            is_trial: selectedDetail.is_trial,
          };
        }
      });

      setSelectedPlanOption(initialSelectedOptions);
    } catch (error) {
      console.error("Error fetching plans:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  const handlePlanOptionChange = (
    planId: string,
    amount: number,
    validity: number,
    validityCount: string,
    type: any,
    isActive: boolean,
    is_trial: boolean,
    originalAmount: number
  ) => {
    setSelectedPlanOption((prevState) => {
      const newState = { ...prevState };
      // Uncheck all other plans first, only if they are not active
      Object.keys(newState).forEach((key) => {
        if (key !== planId && newState[key]?.type === 1) {
          newState[key] = null; // Uncheck other plans that are not active
        }
      });
      newState[planId] = { amount, validityCount, validity, type, isActive, is_trial, originalAmount };
      return newState;
    });
  };

  const handleCheckout = async (planId: string) => {
    console.log("=== Initiating Checkout ===");
    console.log("Plan ID:", planId);

    const selectedOption = selectedPlanOption[planId];
    console.log("Selected Plan Option:", selectedOption);

    if (!selectedOption) {
      console.error("No plan option selected. Aborting checkout.");
      toast.error("Please select a plan option before subscribing");
      return;
    }

    const { amount, validity, type, is_trial, originalAmount } = selectedOption;
    console.log("Extracted Plan Details:", {
      amount,
      validity,
      type,
      is_trial,
      originalAmount,
    });

    setSubscribingPlan(planId);
    console.log("Subscribing plan state updated to:", planId);

    setLoading(true);
    console.log("Loading state set to true.");

    try {
      const urlParams = new URLSearchParams(window.location.search);
      console.log("urlParams userr", urlParams)
      const promotekitReferral = urlParams.get("promotekit_referral") || (window as any).promotekit_referral || "845b390a-cee6-47d9-a8c1-46331b5fa3d5";
      console.log("Retrieved promotekit referral:", promotekitReferral);

      if (!promotekitReferral) {
        console.error("Promotekit referral is not defined.");
        alert("Referral information is missing. Please try again.");
        setLoading(false);
        console.log("Loading state set to false due to missing referral.");
        return;
      }

      // Prepare checkout data
      const data = {
        referral: promotekitReferral,
        amount: amount || 0,
        planId,
        originalAmount: originalAmount || 0,
        type: type || "",
        validity: validity || 0,
      };
      console.log("Constructed Checkout Data:", data);

      // Call API to create a checkout session for the plan
      console.log("Calling createPromoteKitCheckoutSessionUser API...");
      const response = await createPromoteKitCheckoutSessionUser(data);
      console.log("API Response:", response);

      if (response.status === true) {
        console.log("API returned success. Redirecting to:", response.url);
        toast.success(response?.message);
        window.location.href = response.url || window.location.assign(response.url);
      } else {
        console.error("Checkout session creation failed. Response:", response);
        alert("Failed to proceed to checkout. Please try again.");
      }
    } catch (err) {
      console.error("Error creating checkout session:", err);
      toast.error("An error occurred while processing your payment.");
    } finally {
      setLoading(false);
      setSubscribingPlan(null);
      console.log("Reset loading and subscribing plan states.");
    }
    console.log("=== Checkout Flow Completed ===");
  };


  return (
    <section className="container-fluid">
      <SalesPageHeader />

      <div className="plan-container justify-content-center mb-2">
        <div className="col-lg-8 col-md-8 col-sm-12 offset-lg-2 offset-md-2 ">
          <p className="text-muted">
            FRAYO connects food lovers with talented chefs, offering unique dining experiences and personalized meals.
          </p>
        </div>

        {loading ? (
          <div className="col-12 text-center">Loading...</div>
        ) : plans?.length > 0 ? (
          plans
            // ?.filter((plan: any) => subscribedActivePlan?.id === plan.id) // Filter active plans
            .map((plan: any) => (
              <div key={plan?.id} className="col-lg-4 col-md-6 col-sm-12 d-flex" style={{ marginBottom: '32px' }}>
                <div className="plan-box-sales-page card p-4 mb-4 w-100" style={{ marginRight: '16px', marginLeft: '16px' }}>
                  {/* Section: Logo and Title */}
                  <div className="plan-logo-title-section d-flex flex-column align-items-center mb-3">
                    {plan.icon ? (
                      <div style={{ width: '90px', height: '90px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px', borderRadius: '12px', overflow: 'hidden', background: '#fff' }}>
                        <img
                          className="img-fluid"
                          src={plan?.icon}
                          alt="FRAYO"
                          style={{ width: '100%', height: '100%', minWidth: '100%', minHeight: '100%', maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', aspectRatio: '1 / 1', display: 'block', background: 'transparent' }}
                          draggable={false}
                        />
                      </div>
                    ) : null}
                    <h5 className="plan-type fs-12 text-success mb-0 fw-bold text-center mb-2" style={{ minHeight: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', wordBreak: 'break-word' }}>
                      {plan.name}
                    </h5>
                    {plan.description && (
                      <p className="fs-12 justify-content-center text-justify mt-2" style={{ maxWidth: "500px" }}>
                        {plan.description}
                      </p>
                    )}
                  </div>

                  {/* Section: Pricing Option and Amount */}
                  <div className="plan-pricing-section mb-3">
                    <strong className="text-primary" style={{ fontSize: '1.1rem', letterSpacing: '0.5px' }}>Pricing Options</strong>
                    {plan?.plan_details
                      ?.filter((detail: any) => detail.type === 1)
                      ?.map((detail: PlanDetail) => (
                        <div key={detail.validity} className="form-check mt-3 mb-3 ">
                          <>
                            <input
                              type="radio"
                              id={`plan-${plan.id}-${detail.validity}`}
                              name={`plan-${plan.id}`} // Unique group name for each plan
                              value={detail.amount}
                              className="form-check-input"
                              onChange={() => {
                                handlePlanOptionChange(
                                  plan.id,
                                  detail.amount,
                                  detail.validity,
                                  detail.validityCount,
                                  detail.type,
                                  detail.isActive,
                                  detail.is_trial,
                                  detail.originalAmount,
                                );
                              }}
                              checked={(() => {
                                const isPlanActiveCheck =
                                  plan.isPlanActive && detail.isActive && plan.is_trial === detail.is_trial;
                                const isSelectedOptionCheck =
                                  selectedPlanOption[plan.id]?.type === detail.type &&
                                  selectedPlanOption[plan.id]?.amount == detail.amount;
                                return isPlanActiveCheck || isSelectedOptionCheck;
                              })()}
                              disabled={(() => {
                                const isDisabled = plan.isPlanActive && detail.isActive;
                                return isDisabled;
                              })()}
                            />
                            <label
                              className={`form-check-label ${detail.amount === 0
                                ? "text-danger fw-bold"
                                : detail.isActive || (plan.isPlanActive && detail.isActive)
                                  ? "text-danger-light"
                                  : ""
                                }`}
                              htmlFor={`plan-${plan.id}-${detail.validity}`}
                              style={{
                                fontSize: "0.9rem",
                                marginLeft: "0.5rem",
                              }}
                            >
                              {(() => {
                                const amountText = `$${detail.amount.toFixed(2)}`;
                                const trialText = detail.amount === 0 ? " (Trial plan)" : "";
                                return `${amountText} for ${detail.validity}${trialText}`;
                              })()}
                            </label>
                          </>
                        </div>
                      ))}
                  </div>

                  {/* Section: Features */}

                  <div className="plan-features-section mt-3 mb-2" style={{ minHeight: '220px', maxHeight: '220px', overflow: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                    <strong className="text-danger">Features:</strong>
                    <ul className="list-unstyled">
                      {plan.featuresDetails
                        .map((feature: any) => (
                          <li key={feature.id} className="d-flex align-items-center my-2">
                            <img
                              src="../../../assets/images/vector.png"
                              alt="tick"
                              className="me-2"
                              style={{ width: "15px", height: "15px" }}
                            />
                            <span className="me-3" style={{ fontSize: "14px" }}>
                              {feature.name}&nbsp;
                              {feature.description && (
                                <i
                                  className="material-symbols-outlined info-ico me-3"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={feature?.description}
                                  style={{
                                    cursor: "pointer",
                                    position: "relative",
                                    top: "4px",
                                    fontSize: "16px",
                                    width: "20px",
                                    height: "20px",
                                  }}
                                  onClick={() => handleInfoClick(feature.id)}
                                >
                                  info
                                </i>
                              )}
                              {activeFeatureId === feature.id && (
                                <div
                                  style={{
                                    background: "#fff",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                    border: "1px solid #ccc",
                                    position: "absolute",
                                    zIndex: 1,
                                  }}
                                >
                                  {feature.description}
                                </div>
                              )}
                            </span>
                          </li>
                        ))}
                    </ul>
                  </div>

                  {/* Footer: Buy Button */}
                  <div className="col-lg-12 plan-footer d-flex justify-content-center align-items-center mt-3 mb-2">
                    <button
                      className="btn rounded-5 me-2 btn-outline-success"
                      onClick={() => handleCheckout(plan.id)}
                      disabled={loading}
                    >
                      {subscribingPlan === plan.id ? "Subscribing..." : "Buy Now"}
                    </button>
                  </div>
                </div>
              </div>
            ))
        ) : (
          <div className="col-12 text-center">No plans available.</div>
        )}
      </div>
      <SalesPageFooter />
    </section>
  );
};

export default SalesPageUserPromoteKit;
